import React from 'react';
import { RadioGroup, RadioGroupItem } from '../../ui/radio-group';
import { format } from 'date-fns';

const SendRemindersSection = ({
  formData,
  handleInputChange,
  showReminderDate,
  setShowReminderDate,
  isDark
}) => {
  return (
    <div className={`border-none rounded-[16px] p-[20px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)] w-full max-w-[822px] flex flex-col gap-[16px] transition-colors duration-200 ${
      isDark ? 'bg-[#000000]' : 'bg-white'
    }`}>
      {/* Header */}
      <div className={`text-[16px] font-semibold transition-colors duration-200 ${
        isDark ? 'text-white' : 'text-[#072837]'
      }`}>
        Do you wish to send reminders?
      </div>

      {/* Radio buttons for Yes/No */}
      <RadioGroup
        value={formData.sendReminders || ''}
        onValueChange={(value) => {
          if (value === 'yes') {
            setShowReminderDate(true);
            handleInputChange('sendReminders', value);
          } else {
            setShowReminderDate(false);
            handleInputChange('sendReminders', value);
          }
        }}
        className="flex gap-[20px]"
      >
        <label className={`flex items-center gap-[8px] cursor-pointer transition-colors duration-200 ${
          isDark ? 'text-white' : 'text-[#072837]'
        }`}>
          <RadioGroupItem value="yes" id="sendReminders-yes" />
          <span className={`text-[16px] font-normal transition-colors duration-200 ${
            isDark ? 'text-white' : 'text-[#072837]'
          }`}>Yes</span>
        </label>

        <label className={`flex items-center gap-[8px] cursor-pointer transition-colors duration-200 ${
          isDark ? 'text-white' : 'text-[#072837]'
        }`}>
          <RadioGroupItem value="no" id="sendReminders-no" />
          <span className={`text-[16px] font-normal transition-colors duration-200 ${
            isDark ? 'text-white' : 'text-[#072837]'
          }`}>No</span>
        </label>
      </RadioGroup>

      {/* Date/Time Picker - Show when Yes is selected */}
      {showReminderDate && formData.sendReminders === 'yes' && (
        <div className={`border-none rounded-[8px] p-[12px] flex items-center gap-[6px] w-full relative transition-colors duration-200 focus-within:border-solid focus-within:border-[1px] focus-within:border-[#CD6D2C] ${
          isDark ? 'bg-[#161515]' : 'bg-[#f5f5f5] border-solid border-[1px] border-[#f8f9fa]'
        }`}>
          <style>{`
            input[type="datetime-local"]::-webkit-calendar-picker-indicator {
              opacity: 0;
              position: absolute;
              right: 0;
              width: 100%;
              height: 100%;
              cursor: pointer;
            }
            input[type="datetime-local"]::-webkit-inner-spin-button,
            input[type="datetime-local"]::-webkit-clear-button {
              display: none;
            }
          `}</style>
          <input
            type="datetime-local"
            value={formData.reminderDate ? format(new Date(formData.reminderDate), "yyyy-MM-dd'T'HH:mm") : ''}
            onChange={(e) => {
              const date = new Date(e.target.value);
              handleInputChange('reminderDate', date.toString());
            }}
            className={`flex-1 bg-transparent border-0 outline-none text-[16px] pr-[32px] transition-colors duration-200 ${
              isDark
                ? 'text-white placeholder:text-[#b3b3b3]'
                : 'text-[#686868] placeholder:text-[#686868]'
            }`}
          />
          <div
            className="absolute right-[12px] top-1/2 transform -translate-y-1/2 w-[16px] h-[16px] pointer-events-none"
            style={{
              backgroundColor: isDark ? '#b3b3b3' : '#686868',
              WebkitMaskImage: "url('/assets/icons/calendar.svg')",
              WebkitMaskRepeat: 'no-repeat',
              WebkitMaskSize: 'contain',
              WebkitMaskPosition: 'center',
              maskImage: "url('/assets/icons/calendar.svg')",
              maskRepeat: 'no-repeat',
              maskSize: 'contain',
              maskPosition: 'center',
              transition: 'background-color 0.2s ease'
            }}
            aria-hidden="true"
          />
        </div>
      )}
    </div>
  );
};

export default SendRemindersSection;

